// @flow
import { consts as uploaderConsts } from "uploader";
import { asAbsolute } from "root/routes/utils";
import consts from "../data/consts";
import PurchasePage from "../components/PurchasePage";
import SearchPage from "../components/SearchPage";
import ShutterStockTab from "..";

const SRCS = uploaderConsts.SOURCES;

export default [{
	path: asAbsolute(SRCS.SHUTTERSTOCK),
	component: ShutterStockTab,
	routes: [
		{
			path: asAbsolute(SRCS.SHUTTERSTOCK, consts.ROUTES.PURCHASE),
			component: PurchasePage,
		},
		{
			path: asAbsolute(SRCS.SHUTTERSTOCK, consts.ROUTES.SEARCH),
			component: SearchPage,
		}],
}];
